
import { defineComponent, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import api, { authAbortSignal, storage } from './utils/api';
import { checkIsAuthRequired } from './router';
import PlaidLinkContainer from './pages/Plaid/PlaidLinkContainer.vue';
import CookieConsent from './components/CookieConsent.vue';
import { eventEmitter } from './utils/helpers';

let tokenInterval: any = null;
let ordersInterval: any = null;
let nftsInterval: any = null;
let updating = false;
let configUpdating = false;

export default defineComponent({
  components: {
    PlaidLinkContainer,
    CookieConsent
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    const isLoggedIn = computed(() => {
      return store.getters.isLoggedIn;
    });

    const refreshToken = async () => {
      if (updating || !storage.isLoggedIn()) {
        store.dispatch('setIsLoggedIn');
        return;
      }
      updating = true;
      return await api({ url: '/auth/refresh-token', method: 'POST', signal: authAbortSignal }).then(() => {
        store.dispatch('setIsLoggedIn');
      }).finally(() => {
        updating = false;
      });
    };

    onMounted(async () => {
      if (tokenInterval) {
        clearInterval(tokenInterval);
      }
      if (ordersInterval) {
        clearInterval(ordersInterval);
      }
      await refreshToken();
      tokenInterval = setInterval(() => refreshToken(), 180_000 + Math.ceil(Math.random() * 30));
      configUpdating = true;

      // Initialize user profile if logged in
      if (isLoggedIn.value) {
        try {
          await store.dispatch('loadUserProfile');
        } catch (error) {
          console.error('Failed to load user profile:', error);
        }
      }
    });

    onBeforeUnmount(() => {
      configUpdating = false;
      eventEmitter.removeAllListeners();
    });

    watch(isLoggedIn, (val) => {
      if (!val) {
        if (checkIsAuthRequired(route.name as string)) {
          router.replace({ name: 'LoginPage' });
        }
      }
    });

    watch(route, val => {
      if (!storage.isLoggedIn()) {
        console.log("Route", val.path, val.name);
        if (!val.path.includes('registration') && !val.path.includes('login') && !val.path.includes('reset-password') && val.path !== '/') {
          router.push('/login');
        }
        return;
      }
    });

    return {
      isLoggedIn
    };
  }
})
